// StrategyForm validation bounds — mirrored from backend Joi limits.
// Keep these in sync if backend caps ever change.

// Position sizing
export const SIZING_QTY_MIN = 1;
export const SIZING_QTY_MAX = 100000;
export const SIZING_CAPITAL_MIN = 1;
export const SIZING_CAPITAL_MAX = 100000000;

// Trailing-stop-loss — must match the backend Joi schema
// (validators/strategy.validator.js → trailingStopLossSchema)
// and the engine's parseTrailingStopLoss in BacktestService.js.
export const TSL_PCT_MIN = 0.1;
export const TSL_PCT_MAX = 50;

// Target — must match the backend Joi targetSchema and the
// engines' parseTarget. percent: 0.1–500; price: > 0.
export const TARGET_PCT_MIN = 0.1;
export const TARGET_PCT_MAX = 500;
export const TARGET_PRICE_MIN = 0.01;
export const TARGET_PRICE_MAX = 100000000;

// Brokerage — must match the backend brokerageConfigSchema
// (validators/strategy.validator.js) and the engine's
// parseBrokerage in BacktestService.js: both sides 0–5 percent.
export const BROKERAGE_PCT_MIN = 0;
export const BROKERAGE_PCT_MAX = 5;
